/*
    HomeGateRoom HOMEGATE By the Road Outside a House
    Pic homegate
    Hints 2002
    InformOnEntry Here is the old house at last. Uncle Julius is probably inside working in his laboratory. You may as well just go in.
    RoomScriptBox PANEL 66 120 63 26 PANEL
    HitDisable PANEL
    RoomScriptBox LOCK 66 120 63 25 GATELOCK Examine
    HitDisable LOCK
    GoBox GATE 45 95 103 184 WORKSHOP
    HitDisable GATE
    RoomScriptBox STARTWALK 0 90 180 230 STARTWALK Left
*/

function HomeGateRoom(game) {

    this.Room_constructor(game, 'homegate');

    this.xPos = -188;
}

createjs.extend(HomeGateRoom, Room);

HomeGateRoom.prototype.preload =
    function () {
        this.manifest =
            this.makeManifest(this.id, [
                '#scene', 'wall', 'panel-frames', 'gate-overlay',
                {full_id: 'sound-ahhh', full_src: 'sounds/ahhh.wav'},
                {full_id: 'sound-footstep', full_src: 'sounds/homegate-footstep.wav'},
                {full_id: 'sound-reveal-panel', full_src: 'sounds/homegate-panel.wav'}
            ]);

        this.Room_preload(this.manifest);
    };

HomeGateRoom.prototype.load =
    function () {
        this.Room_load();

        /* Audio */
        this.sndAhhh = this.world.queue.getResult('sound-ahhh');
        this.sndFootstep = this.world.queue.getResult('sound-footstep');
        this.sndOpenPanel = this.world.queue.getResult('sound-reveal-panel');

        /* The wall graphic slides rightward as you walk */
        this.loadWall();

        /* The two-frame panel, either open showing lock or closed -- an ordinary gate */
        this.loadPanel();

        /* The open gate, after the puzzle is solved */
        this.loadGate();

        if (!this.data('atGate')) {
            /* The hit area for walking */
            this.loadWalkArea();
        }

        /* The gate panel area (only half as tall as the sprite it sits over) */
        this.loadPanelArea();

        return this;
    };

HomeGateRoom.prototype.enter =
    function () {
        this.Room_enter(
            'Here is the old house at last. Uncle Julius is probably inside working in his laboratory. You may as well just go in.'
        );

        return this;
    };

HomeGateRoom.prototype.leave =
    function (nextKey) {
        this.Room_leave(nextKey);
    };

HomeGateRoom.prototype.next =
    function (nextKey) {
        if (nextKey == 'lock')
            return new GateLockRoom(this.world);
        else if (nextKey == 'house')
            return new ByHouseRoom(this.world);
    };

HomeGateRoom.prototype.loadGate =
    function () {
        this.artGateOverlay = ujPut(new createjs.Bitmap(this.world.queue.getResult('homegate-gate-overlay')), 45, 95, 'gate');
        this.artGateOverlay.gameCursor = 'go';
        this.artGateOverlay.alpha = this.data('gateOpen') ? 1 : 0;
        this.artGateOverlay.on('click', function () { this.leave('house'); }, this);
        this.reg(this.artGateOverlay);
    };

HomeGateRoom.prototype.loadPanel =
    function () {
        var artPanelFrameData = {
            images: [this.world.queue.getResult('homegate-panel-frames')],
            frames: {width: 63, height: 50, count: 2},
            animations: {closed: 0, open: 1}
        };

        this.artPanelFrames = new createjs.SpriteSheet(artPanelFrameData);
        this.artPanel = ujPut(new createjs.Sprite(this.artPanelFrames), 66, 121, 'panel');
        this.artPanel.visible = this.data('panelOpen');
        this.reg(this.artPanel);
    };

HomeGateRoom.prototype.loadWall =
    function () {
        this.artWall = ujPut(new createjs.Bitmap(this.world.queue.getResult('homegate-wall')), this.data('atGate') ? 0 : this.xPos, 0, 'wall');
        this.reg(this.artWall);
    };

HomeGateRoom.prototype.tweenWalk =
    function () {

        if (this.artWall.x < 0) {

            var x = Math.min(0, this.artWall.x + 27);

            createjs.Sound.play('sound-footstep', {volume: 0.2});

            createjs.Tween.get(this.artWall)
                .to({x: x}, 600)
                .call(this.tweenWalk, {}, this);
        }
        else {
            this.data('atGate', true);
            this.artPanel.visible = true;
            this.areaPanel.visible = true;
            this.resetCursor();
        }
    };

HomeGateRoom.prototype.loadWalkArea =
    function () {
        this.areaWalk = this.makeHitRect(0, 90, 180, 230, 'walk', 'left');
        var xCur = this.xPos;

        var areaWalkListener = this.areaWalk.on('click', function (mouseData) {
            this.areaWalk.off(areaWalkListener);
            this.areaWalk.gameCursor = 'default';
            this.tweenWalk();
        }, this);

        this.reg(this.areaWalk);
    };

HomeGateRoom.prototype.loadPanelArea =
    function () {
        this.areaPanel = this.makeHitRect(66, 121, 63, 25, 'panel-look', 'action');
        this.areaPanel.visible = this.data('atGate') && !this.data('gateOpen');

        this.areaPanel.on('click', function (mouseData) {

            if (this.data('panelOpen')) {
                this.leave('lock');
                createjs.Sound.play('sound-ahhh', {volume: 0.2});
            } else {
                this.areaPanel.gameCursor = 'examine';
                this.resetCursor();
                this.artPanel.gotoAndStop('open');
                createjs.Sound.play('sound-reveal-panel', {volume: 0.2});
                this.data('panelOpen', true);
            }

        }, this);

        this.reg(this.areaPanel);
    };

createjs.promote(HomeGateRoom, 'Room');
